import React, { createContext, useState, useContext, useEffect } from 'react';
import AlertModal from '../components/Alerts/AlertModal';
import websocketService from '../services/websocketService';

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    title: '',
    content: '',
  });

  useEffect(() => {
    // Conectar al WebSocket cuando el componente se monta
    websocketService.connect();
    
    // Configurar el callback para recibir alertas
    websocketService.setAlertCallback((data) => {
      showAlert({
        title: data.title || 'Notificación',
        content: data.message || data.content || 'Nuevo mensaje recibido'
      });
    });

    // Limpiar al desmontar
    return () => {
      websocketService.disconnect();
    };
  }, []);

  const showAlert = ({ title, content }) => {
    setAlertState({
      isOpen: true,
      title,
      content,
    });
  };

  const hideAlert = () => {
    setAlertState({
      isOpen: false,
      title: '',
      content: '',
    });
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <AlertModal
        open={alertState.isOpen}
        title={alertState.title}
        content={alertState.content}
        onOk={hideAlert}
        onCancel={hideAlert}
      />
    </AlertContext.Provider>
  );
}; 